import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { AddressPill } from '@react/components/addresses/AddressPill'
import { erc20WeiToCommaDecString } from '@shared/conversions'
import { RewardsPlanCTO, RewardsPlanRowCTO } from '@shared/RewardsPlanCTO'
import dayjs from 'dayjs'
import { ZeroAddress } from 'ethers'
import React from 'react'

function RewardsViewRow(props: {
  rewardsPlanRow: RewardsPlanRowCTO
  rowKey: string
  nextRewardsPlanRow: RewardsPlanRowCTO | undefined
}): React.ReactElement {
  const { rewardsPlanRow, rowKey } = props

  return (
    <TableRow key={rowKey}>
      <TableCell sx={{ paddingX: 1, textAlign: 'center' }}>
        {props.nextRewardsPlanRow && (
          <Typography variant="caption">
            {`${erc20WeiToCommaDecString(rewardsPlanRow.minimumPrincipalEarningInterest)} - ${erc20WeiToCommaDecString(props.nextRewardsPlanRow.minimumPrincipalEarningInterest)}`}
          </Typography>
        )}
        {!props.nextRewardsPlanRow && (
          <Typography variant="caption">
            {`${erc20WeiToCommaDecString(rewardsPlanRow.minimumPrincipalEarningInterest)} - Infinity`}
          </Typography>
        )}
      </TableCell>

      <TableCell sx={{ paddingX: 1, textAlign: 'center' }}>
        <Typography variant="caption">{`${rewardsPlanRow.interestRate.toFixed(2)} %`}</Typography>
      </TableCell>
      <TableCell sx={{ paddingX: 1, textAlign: 'center' }}>
        <Typography variant="caption">{Number(rewardsPlanRow.dailyInterestRate).toFixed(4)} %</Typography>
      </TableCell>
    </TableRow>
  )
}
// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export default function RewardCard(props: { rewardsPlan: RewardsPlanCTO; onEdit?: () => void }): React.ReactElement {
  const { rewardsPlan, onEdit } = props

  return (
    <Paper sx={{ padding: 3, border: '1px solid', borderColor: 'grey.200', width: '100%' }}>
      <Box data-testid="rewards-edit-form">
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          {rewardsPlan.accountAddr !== ZeroAddress && (
            <Typography variant="bodyBold">{rewardsPlan.companyName}</Typography>
          )}
          {rewardsPlan.accountAddr !== ZeroAddress && <AddressPill addr={rewardsPlan.accountAddr} />}
          {rewardsPlan.accountAddr == ZeroAddress && (
            <Typography variant="bodyBold">Default rewards for all lenders</Typography>
          )}
          <Typography variant="bodyBold">{`${dayjs(rewardsPlan.startDateString).format('DD MMM, YYYY')} - ${dayjs(rewardsPlan.endDateString).format('DD MMM, YYYY')}`}</Typography>
          {onEdit && <Button onClick={onEdit}>Edit</Button>}
        </Box>
        <Table key="table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingX: 2, textAlign: 'center' }}>
                <Typography variant="caption">Investment Range</Typography>
              </TableCell>
              <TableCell sx={{ paddingX: 2, textAlign: 'center' }}>
                <Typography variant="caption">Annual Reward Rate</Typography>
              </TableCell>
              <TableCell sx={{ paddingX: 1, textAlign: 'center' }}>
                <Typography variant="caption">Daily Reward Rate</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rewardsPlan.rewardsPlanRows.map((rewardsPlanRow, index) => (
              <RewardsViewRow
                key={'Row' + index}
                rowKey={'Row' + index}
                rewardsPlanRow={rewardsPlanRow}
                nextRewardsPlanRow={rewardsPlan.rewardsPlanRows[index + 1] ?? undefined}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  )
}
